import {InvoiceSendStatusCd} from '../';
import {EnumHelper} from './enum-helper';

export class InvoiceSendStatusCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in InvoiceSendStatusCd ) {
      this._values.push(InvoiceSendStatusCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): InvoiceSendStatusCd {

    for ( const obj in InvoiceSendStatusCd ) {
      if (InvoiceSendStatusCd[obj] === value){
        return InvoiceSendStatusCd[obj] as InvoiceSendStatusCd;
      }
    }
  }
}

const InvoiceSendStatusCdHelper = new InvoiceSendStatusCdHelperEnumHelperClass();
export default InvoiceSendStatusCdHelper;
